// extracted by mini-css-extract-plugin
export default {"container":"CustomPageContainer_container__2KWSR","list_padding_bottom":"CustomPageContainer_list_padding_bottom__nsQ8j"};